/* eslint-disable space-before-function-paren */
import { HTTP, DefaultErrorHandler } from "@/utils/http-common"

export default {
  get($, company) {
    //   GET /admin/companies/ (list all companies)
    return new Promise((resolve, reject) => {
      return HTTP.get(`/admin/companies/${company}/`)
        .then(r => {
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  list($) {
    //   GET /admin/companies/ (list all companies)
    return new Promise((resolve, reject) => {
      return HTTP.get("/admin/companies/")
        .then(r => {
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  create($, form) {
    return new Promise((resolve, reject) => {
      return HTTP.post("/admin/companies/", form)
        .then(r => {
          $.$store.commit("success", "Company updated !")
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  update($, form, id) {
    form = {
      name: form.name,
      email: form.email,
      phone_number: form.phone_number,
      website: form.website,
      address: form.address,
      zip_code: form.zip_code,
      city: form.city,
      region: form.region,
      country: form.country
    }
    return new Promise((resolve, reject) => {
      return HTTP.patch(`/admin/companies/${id}/`, form)
        .then(r => {
          $.$store.commit("success", "Company updated !")
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  update_by_invitation($, form, id, invitation_key) {
    // PUT /admin/users/
    // PUT /admin/company/
    form = {
      merchant: form.merchant,
      username: form.username,
      email: form.email,
      first_name: form.first_name,
      last_name: form.last_name,
      password: form.password,
      password2: form.password2,
      invitation_key: invitation_key
    }
    return new Promise((resolve, reject) => {
      return HTTP.patch(`/admin/users/${id}/update_by_invitation/`, form)
        .then(r => {
          $.$store.commit("success", "User updated")
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  delete($, id) {
    // DELETE /admin/company/:id
    return new Promise((resolve, reject) => {
      return HTTP.delete(`/admin/companies/${id}/`)
        .then(r => {
          $.$store.commit("success", "Company removed")
          resolve(r.data)
        })
        .catch(e => {
          DefaultErrorHandler(e, reject)
        })
    })
  },
  User: {
    list_by_company($, company) {
      //   GET /admin/users/?company=himydata (list users of a company)
      return new Promise((resolve, reject) => {
        return HTTP.get("/admin/users/?company=" + company)
          .then(r => {
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    },
    get($, id) {
      // GET /admin/users/:id (Not needed)
      return new Promise((resolve, reject) => {
        return HTTP.get(`/admin/users/${id}/`)
          .then(r => {
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    },
    list($, paginate = {}, merchant, username = null) {
      // GET /admin/users/?company=himydata (list of a certain company)
      // GET /admin/users/ (list of all companies)
      return new Promise((resolve, reject) => {
        return HTTP.get(
          "/admin/users/?page=" +
            paginate.page +
            "&page_size=" +
            paginate.page_size +
            (merchant ? "&merchant=" + merchant : "") +
            (username ? "&username=" + username : "")
        )
          .then(r => {
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    },
    create($, form) {
      // POST /admin/users/
      form = {
        merchant: form.merchant, // slug
        username: form.email,
        email: form.email,
        first_name: form.first_name,
        last_name: form.last_name,
        is_admin: form.is_admin,
        is_brand_user: form.is_brand_user,
        is_contributor: form.is_contributor,
        is_viewer: form.is_viewer,
        company: $.$store.state.user.company,
        groups: form.groups
      }
      return new Promise((resolve, reject) => {
        return HTTP.post("/perfumist/users/", form)
          .then(r => {
            $.$store.commit("success", "User created !")
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    },
    update($, form, id) {
      // PUT /admin/users/
      // PUT /admin/company/
      form = {
        username: form.username,
        is_admin: form.is_admin,
        is_brand_user: form.is_brand_user,
        is_contributor: form.is_contributor,
        is_viewer: form.is_viewer,
        email: form.email,
        first_name: form.first_name,
        last_name: form.last_name,
        groups: form.groups
      }
      return new Promise((resolve, reject) => {
        return HTTP.patch(`/admin/users/${id}/`, form)
          .then(r => {
            $.$store.commit("success", "User updated")
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    },
    delete($, id) {
      // DELETE /admin/users/:id
      // DELETE /admin/company/:id
      return new Promise((resolve, reject) => {
        return HTTP.delete(`/admin/users/${id}/`)
          .then(r => {
            $.$store.commit("success", "User deleted")
            resolve(r.data)
          })
          .catch(e => {
            DefaultErrorHandler(e, reject)
          })
      })
    }
  },
  Organism: {
    get($, id) {
      return new Promise((resolve, reject) => {
        const msg = "Api non implémenté"
        $.$store.commit("error", { msg: msg, color: "error" })
        reject(new Error(msg))
      })
    },
    list($) {
      return new Promise((resolve, reject) => {
        const organisms = [
          {
            name: "BNP1",
            type: "PSPS",
            slug: "bnp1",
            companies: []
          }
        ]
        resolve({ results: organisms })
        // const msg = 'Api non implémenté'
        // $.$store.commit('error', { msg: msg, color: 'error' })
        // reject(new Error(msg))
      })
    },
    delete($, id) {
      return new Promise((resolve, reject) => {
        const msg = "Api non-implemented"
        $.$store.commit("error", { msg: msg, color: "error" })
        reject(new Error(msg))
      })
    },
    update($, id, form) {
      return new Promise((resolve, reject) => {
        const msg = "Api non-implemented"
        $.$store.commit("error", { msg: msg, color: "error" })
        reject(new Error(msg))
      })
    },
    create($, form) {
      return new Promise((resolve, reject) => {
        const msg = "Api non-implemented"
        $.$store.commit("error", { msg: msg, color: "error" })
        reject(new Error(msg))
      })
    }
  }
}
